import { useState } from "react";
import { AdminUser } from "../../../services/types/adminUser.type";
import { ItemMenu } from "../../ui/ItemMenu/ItemMenu";
import { BorderWrap } from "../../ui/wrappers/BorderWrap/BorderWrap";
import "./UserItem.css";
import { useHardDeleteUserMutation } from "../../../store/adminUsers/adminUsersApi";
import { TextButton } from "../../ui/buttons/TextButton/TextButton";
import { VerticalLine } from "../../ui/visual/VerticalLine/VerticalLine";

interface UserItemProps {
  user: AdminUser;
  onActionComplete: () => void;
}

export const UserItem = ({ user, onActionComplete }: UserItemProps) => {
  const [showMenu, setShowMenu] = useState(false);
  const [hardDelete] = useHardDeleteUserMutation();

  const menuClick = () => {
    setShowMenu((showMenu) => !showMenu);
  };

  const handleHardDelete = async () => {
    await hardDelete(user.email);
    onActionComplete();
  };

  return (
    <BorderWrap>
      <div className="user-item-wrap">
        <div className="user-item-name">
          <p>{user.firstName}</p>
          <p>{user.lastName}</p>
        </div>
        <VerticalLine />
        <div className="user-item-email">
          <p>{user.email}</p>
          {user.emailConfirmed ? (
            <p className="user-item-email-confirmed">Подтвержден</p>
          ) : (
            <p className="user-item-email-noconfirmed">Не подтвержден</p>
          )}
        </div>
        <VerticalLine />
        <div className="user-item-phone">{user.phone}</div>
        <VerticalLine />
        <div className="user-item-role">{user.role}</div>
        <VerticalLine />
        <div>
          <ItemMenu showMenu={showMenu} menuClick={menuClick}>
            <TextButton text="Удалить" action={handleHardDelete} />
          </ItemMenu>
        </div>
      </div>
    </BorderWrap>
  );
};
